import { InviteRow } from '@/types/adminInvites';
import { InviteColumns, InviteColumn } from '@/constants/inviteColumns';

// MM-42243: stringify the canonical grid rows back into the CSV the :load endpoint expects. Parsing stays entirely
// server-side (DataWeaver); the client only needs to WRITE a CSV, which is simple. The header row and column order
// come from InviteColumns, the same schema the grid renders, so a round-trip (parse -> edit -> serialize -> load)
// preserves every column. RFC-4180 quoting is applied to any cell containing a comma, quote, or newline.

function escapeCell(value: string): string {
  if (/[",\r\n]/.test(value))
    return '"' + value.replace(/"/g, '""') + '"';
  return value;
}

function cellToString(row: InviteRow, col: InviteColumn): string {
  const value = (row as Record<string, unknown>)[col.key as string];
  if (value == null)
    return '';
  if (typeof value === 'boolean')
    return value ? 'true' : 'false';
  return String(value);
}

// Serializes rows to a CSV string: a header line of the 23 column headers in schema order, then one line per row.
export function serializeInvitesCsv(rows: InviteRow[]): string {
  const header = InviteColumns.map(col => escapeCell(col.header)).join(',');
  const lines = rows.map(row => InviteColumns.map(col => escapeCell(cellToString(row, col))).join(','));
  return [header, ...lines].join('\r\n');
}
